export const sortDestinationsBasedOnError = (destinations: any[]) =>{
  return destinations
    .sort((destinationA, destinationB) => {
      if (destinationA.error && destinationB.error) {
        return 0;
      }

      return destinationA.error ? 1 : -1;
    })
    .map((destination, index) => ({ ...destination, sortOrder: index }));
}
